const EcommerceIcon = ({ width }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90" width={width}>
    <g fill="#666">
      <path d="M42.17,68.63A4.69,4.69,0,1,1,46.85,64h0A4.68,4.68,0,0,1,42.17,68.63Zm0-7.6a2.91,2.91,0,1,0,2.91,2.91A2.91,2.91,0,0,0,42.17,61Z" />
      <path d="M64.29,68.63A4.69,4.69,0,1,1,69,64h0A4.68,4.68,0,0,1,64.29,68.63Zm0-7.6a2.91,2.91,0,1,0,2.91,2.91A2.91,2.91,0,0,0,64.29,61Z" />
      <path d="M72.09,57.14h-39a.88.88,0,0,1-.86-.7L25.59,24.78h-8.7a.89.89,0,0,1,0-1.78H26.3a.9.9,0,0,1,.87.71l6.67,31.66H72.09a.89.89,0,1,1,0,1.77Z" />
      <path d="M71.6,49.78h-40a.89.89,0,0,1,0-1.78H70.81l1.76-16.07L27.25,29.48a.89.89,0,0,1,.1-1.77l46.25,2.5a.88.88,0,0,1,.84.93v.05l-2,17.8A.89.89,0,0,1,71.6,49.78Z" />
      <path d="M72.57,41h0L29.38,39.51a.9.9,0,0,1-.86-.92.88.88,0,0,1,.92-.85L72.6,39.18a.89.89,0,0,1,0,1.78Z" />
      <path d="M40.51,49.78a.88.88,0,0,1-.88-.81l-1.7-19.68a.89.89,0,0,1,1.77-.15h0l1.7,19.67a.9.9,0,0,1-.81,1Z" />
      <path d="M51.47,49.78a.89.89,0,0,1-.89-.89h0v-19a.89.89,0,1,1,1.77,0v19A.88.88,0,0,1,51.47,49.78Z" />
      <path d="M61.86,49.78H61.8a.89.89,0,0,1-.82-1h0l1.3-18.36a.87.87,0,0,1,.94-.82.89.89,0,0,1,.83,1L62.75,49A.89.89,0,0,1,61.86,49.78Z" />
    </g>
  </svg>
);

export default EcommerceIcon;
